"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconNamePropType = getIconNamePropType;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var propType;

function getIconNamePropType() {
  if (!propType) {
    var iconNames = []; // Optimization: omit this require in production builds (which skip proptype validation)

    if (process.env.NODE_ENV !== 'production') {
      var interopRequire = function interopRequire(mod) {
        return mod && mod['default'] || mod;
      }; // #8679


      iconNames = interopRequire(require('icons/iconNames'));
    }

    propType = _propTypes.default.oneOf(iconNames);
  }

  return (0, _createChainablePropType.default)(propType, 'iconName');
}